import { defineStore } from "pinia";

export const useBoardingStore = defineStore('boarding', {
  state: () => ({
    boarding: {},
    boardings: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setBoarding(boarding) {
      this.boarding = boarding
    },
    setBoardings(boardings) {
      this.boardings = boardings
    },
    addBoarding(boarding) {
      this.boardings.unshift(boarding)
    },
    updateBoarding(boarding) {
      let index = this.boardings.findIndex(cl => cl.id === boarding.id)
      this.boardings.splice(index, 1, boarding)
    },
    deleteBoarding(boarding) {
      let index = this.boardings.findIndex(cl => cl.id === boarding.id)
      this.boardings.splice(index, 1)
    },
  },
});